//#region [IMPORT]

// === THIRD-PARTY ===
import React, {  } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import {
  Check,
} from '@mui/icons-material';

//#endregion

//-----------------------------------------------------------------
export function OptionEnabled() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme        = useTheme();

  const setting_snippets_enabled = localStorage.getItem( 'setting-snippets-enabled' ) || '0';

  const _is_active = setting_snippets_enabled === '1' ? '' : 'hidden';
  const _icon      = <Check sx={{visibility: _is_active }} />;
  const _text      = 'Enable';
  
  const _hover_theme = theme.palette.mode === 'light' ? 'secondary' : 'primary';

  const is_light = theme.palette.mode === 'light';

  const _styles = {
    container: {
      display    : 'flex'   ,
      marginLeft : 'auto'   ,
      alignItems : 'center' ,
      padding    : '0.5rem' ,
      cursor     : 'pointer',

      '&:hover': {
        background: theme.palette.background[_hover_theme][theme.palette.mode],
      },
    },
    icon: {
      color: is_light ? theme.palette.primary.main : '',
    },
    text: {
      paddingLeft: '0.5rem',
    }
  }

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function toggle() {
    //-----------------------------------------------------------------
    const value = setting_snippets_enabled === '0' ? 1 : 0;
    localStorage.setItem('setting-snippets-enabled', value );
  }
  
  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
      return (
        <Box sx={_styles.container} onClick={toggle}>
          {_icon}
          <Box sx={_styles.text}> {_text} </Box>
        </Box>
      );
  }

  //#endregion

  return display();
}